import Vue from 'vue/dist/vue.esm.js'
import axios from 'axios'

export class RobotComp {
  constructor() {
    if (document.getElementById('js-products_comp') == null) return
    axios.get('/wp-json/wp/v2/custom/product').then(function (res) {
      const vm = new Vue({
        el: '#vue-products-comp',
        data: {
          posts: res.data,
          isRobot0: vueProductsData0,
          isRobot1: vueProductsData1,
          isRobot2: vueProductsData2,
        },
        computed: {
          filteredPosts01: function () {
            let posts
            posts = this.posts.filter((post) => {
              return post.slug.includes(this.isRobot0)
            })
            return posts
          },
          filteredPosts02: function () {
            let posts
            posts = this.posts.filter((post) => {
              return post.slug.includes(this.isRobot1)
            })
            return posts
          },
          filteredPosts03: function () {
            let posts
            posts = this.posts.filter((post) => {
              return post.slug.includes(this.isRobot2)
            })
            return posts
          },
        },
        mounted() {},
        methods: {},
      })
    })
  }
}
